//import stuff
import React, { Component } from 'react'
import styles from './header.module.css'
// import cn from '../../utils/classNameConcat'
 
   
//the class you are making your component from
class Header extends Component {
  // constructor to set state and bind "this"
  constructor(props) {
      super(props);
      this.state = { showMenu: true};
      this.handleClick = this.handleClick.bind(this);
    }

  // function to handle the click
   handleClick() {
    this.setState(prevState => ({
       showMenu: !prevState.showMenu
    }));
  }
  
  // the render() method to put stuff into the DOM
  render() {
    
    // the return() to put your default HTML into the DOM
    return (
        // wrapper div of component
        <header className={styles.headerContainer}>
      {/* <div className={styles.headerGrow}/> */}
      <a aria-current="page" className={styles.headerLink} href="/">
        AjayDoddapaneni
      </a>
      <nav className={styles.navContainer}>
        <button className={styles.navMenuButton} onClick={this.handleClick}>Menu</button>
        <ul className={this.state.showMenu ? styles.headeMenuList: styles.headeMenuListHide}>
          <li className={styles.headeMenuListItem}>
            <a className={styles.headeMenuListLink} href="/">home</a>
          </li>
          <li className={styles.headeMenuListItem}>
            <a className={styles.headeMenuListLink} href="/contact">contact</a>
          </li>
          <li className={styles.headeMenuListItem}>
            <a className={styles.headeMenuListLink} href="/about">about</a>
          </li>
          <li className={styles.headeMenuListItem}>
            <a className={styles.headeMenuListLink} href="/contact">resume</a>
          </li>
         </ul>
        </nav>
  
    </header>
    );
  }
}
// export the class so you can call it elsewhere
export default Header;